import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { buildApiUrl } from "../config/api";

export const DataContext = createContext({});

export const DataProveder = ({ children }) => {
  const ambiente = process.env.REACT_APP_AMBIENTE;

  //todas las tiendas
  const [allStores, setAllStores] = useState(null);
  const [storaName, setStoraName] = useState(null);

  // Obtener OrganizationID del localStorage
  const organizationID = localStorage.getItem("organizationID");
  const role = localStorage.getItem("role");

  // tengo todas las tiendas
  const getStores = async () => {
    if (organizationID) {
      try {
        const res = await axios.get(
          `${buildApiUrl("/ep_StoreEcart")}?OrganizationID=${organizationID}`,
        );
        if (res.status === 200) {
          setAllStores(res.data);
        }
      } catch (error) {
        console.log("Error al realizar la solicitud:", error);
        console.log(null);
      }
    }
  };

  // Función que mapea todas las tiendas por su nombre personalizado
  useEffect(() => {
    if (allStores) {
      const storeNames = allStores.map((store) => ({
        name: store.Name || store.Ecommerce, // Usa Name si existe, sino Ecommerce
        ecommerce: store.Ecommerce, // Tipo de ecommerce (para referencia)
        shopId: store.ShopId, // ID único de la tienda
      }));
      setStoraName(storeNames);
    }
  }, [allStores]);

  useEffect(() => {
    getStores();
  }, []);

  return (
    <DataContext.Provider value={{ allStores, storaName, ambiente, role }}>
      {children}
    </DataContext.Provider>
  );
};
